var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullscreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28622 3.64062V5.63579C6.28622 6.37039 5.69071 6.96591 4.95611 6.96591H2.96094",
    stroke: "white",
    strokeWidth: 0.997585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2763 14.2812L10.2763 12.2861C10.2763 11.5515 10.8718 10.956 11.6064 10.956L13.6016 10.956",
    stroke: "white",
    strokeWidth: 0.997585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6016 6.96591L11.6064 6.96591C10.8718 6.96591 10.2763 6.3704 10.2763 5.63579L10.2763 3.64062",
    stroke: "white",
    strokeWidth: 0.997585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96094 10.956L4.95611 10.956C5.69071 10.956 6.28622 11.5515 6.28622 12.2861L6.28622 14.2813",
    stroke: "white",
    strokeWidth: 0.997585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenIcon);
export default __webpack_public_path__ + "static/media/fullscreen-icon.e92b406b7c4b564630614a3250feb85e.svg";
export { ForwardRef as ReactComponent };